import { NavLink, Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { EccArea } from "@/api/types";

// Custodias visible siempre; catálogo vacío hasta DPECC-F.
// La capability ecc.custodias se gateará en frontend cuando Fase 10 entregue el JWT de licencia.
const AREAS: { id: EccArea; label: string }[] = [
  { id: "nova", label: "NOVA" },
  { id: "soporte", label: "Soporte" },
  { id: "crea", label: "CREA" },
  { id: "custodias", label: "Custodias" },
];

const SUB_NAV = [
  { to: "/ecc", label: "Hub", end: true },
  { to: "/ecc/new", label: "Nuevo análisis", end: false },
  { to: "/ecc/calls", label: "Buscar llamada", end: false },
  { to: "/ecc/catalog", label: "Catálogo", end: false },
  { to: "/ecc/queue", label: "Cola de aprobación", end: false },
  { to: "/ecc/history", label: "Historial", end: false },
  { to: "/ecc/new-srp", label: "Nuevo SRP ECC", end: false },
];

export function ECCPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const area = (params.get("area") ?? "nova") as EccArea;

  function setArea(next: EccArea) {
    const url = new URL(window.location.href);
    url.searchParams.set("area", next);
    navigate({ search: url.searchParams.toString() }, { replace: true });
  }

  return (
    <div className="flex h-full flex-col gap-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">
            Evaluación de Calidad Corporativa
          </h1>
          <p className="text-sm text-muted-foreground">
            Análisis de llamadas por área — CDR + grabaciones + criterios de calidad.
          </p>
        </div>
        <div className="flex items-center gap-1 rounded-lg border bg-muted/50 p-1">
          {AREAS.map((a) => (
            <button
              key={a.id}
              type="button"
              onClick={() => setArea(a.id)}
              className={cn(
                "rounded-md px-4 py-1.5 text-sm font-medium transition-colors",
                area === a.id
                  ? "bg-card text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground",
              )}
            >
              {a.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-1 border-b">
        {SUB_NAV.map((item) => (
          <NavLink
            key={item.to}
            to={{ pathname: item.to, search: `?area=${area}` }}
            end={item.end}
            className={({ isActive }) =>
              cn(
                "rounded-t-md border-b-2 px-4 py-2 text-sm font-medium transition-colors",
                isActive
                  ? "border-primary text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground",
              )
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>

      <div className="flex-1">
        <Outlet context={{ area }} />
      </div>
    </div>
  );
}
